export default __webpack_public_path__ + "static/media/2 - Семейный спорт.835661bc.jpg";